import { motion } from "framer-motion";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

import { ANIMATION_DURATION } from "@/constants/animations.constants";
import { useTranslation } from "@/core/i18n";
import { MobileViewportContainer } from "@/modules/onboarding/components/MobileViewportContainer/MobileViewportContainer";
import { OnboardingBackButton } from "@/modules/onboarding/components/OnboardingBackButton/OnboardingBackButton";
import { useOnboardingContext } from "@/modules/onboarding/context";
import { NameForm, type NameFormData } from "@/modules/onboarding/forms/NameForm/NameForm";

const V3NamePage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { profile, updateProfileState } = useOnboardingContext();
  const initialFirstName = profile.firstName ?? "";
  const initialLastName = profile.lastName ?? "";

  const handleSubmit = useCallback(
    async (data: NameFormData) => {
      updateProfileState({
        firstName: data.firstName,
        lastName: data.lastName,
      });
      navigate("/signin/email");
    },
    [navigate, updateProfileState],
  );

  return (
    <MobileViewportContainer header={<OnboardingBackButton />}>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: ANIMATION_DURATION, delay: 0.1 }}
        className="flex w-full max-w-sm flex-col items-center gap-9"
      >
        <NameForm
          key={`name-${initialFirstName}-${initialLastName}`}
          initialFirstName={initialFirstName}
          initialLastName={initialLastName}
          onSubmit={handleSubmit}
          submitButtonText={t("common.confirm")}
        />
      </motion.div>
    </MobileViewportContainer>
  );
};

export default V3NamePage;
